import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
	providedIn: 'root',
})
export class AdminGuardService implements CanActivate, CanLoad {
	constructor(private router: Router, private authService: AuthService) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authService.isAuthenticated() && this.authService.getUser().hasRoles(['ADMIN'])) {
			return true;
		} else {
			this.router.navigate(['/']);
			this.authService.login();
			return false;
		}
	}

	canLoad(): boolean {
		if (this.authService.isAuthenticated() && this.authService.getUser().hasRoles(['ADMIN'])) {
			return true;
		} else {
			this.router.navigate(['/']);
			this.authService.login();
			return false;
		}
	}
}
